function facebookShare({img, title, caption, url}){
    if(img && title && caption && url){
        FB.ui({
            method: 'share_open_graph',
            action_type: 'og.shares',
            action_properties: JSON.stringify({
                object: {
                    'og:url': url,
                    'og:title': title,
                    'og:description': caption,
                    'og:image': img
                }
            })
        },
        function (response) {
            console.log(response);
        });
    } else {
        FB.ui({
            method: 'share',
            href: window.location.href,
        }, function(response){});
    }


}

function twitterShare(){
  const url=window.location.href;
  // const shareUrl=`https://twitter.com/share?url=${url}&via=RDS_official`;
  const shareUrl=`https://twitter.com/share?url=${url}`;
  let a = document.createElement("a");
  a.href=shareUrl;
  a.target='_blank';
  a.click();
}

function copyToClipboard(me){
    $(me).addClass("clicked");
    var dummy = document.createElement('input'),
    text = window.location.href;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

    setTimeout( function() {
        $(me).removeClass("clicked");
    }, 400 );
}




window.facebookShare=facebookShare;
window.twitterShare=twitterShare;
window.copyToClipboard=copyToClipboard;
